import React from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const AutocompleteEmail = (props) => {
    return (
        <Autocomplete
            {...props}
            multiple
            id="tags-standard"
            options={props.data}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    label="Email Addresses"
                    placeholder="Email Addresses"
                />
            )}
        />
    );
};

export default AutocompleteEmail;
